import React from 'react';
import { motion } from 'framer-motion';
import { ParallaxSection } from './ParallaxSection';
const CTA_BG = 'https://cdn.magicpatterns.com/uploads/gSWTzHhYW4DyyfK4mQXJZD/hal-gatewood-hfP4PkRN0mw-unsplash.jpg';
export function FinalCTA() {
  return <ParallaxSection bgImage={CTA_BG} overlayOpacity={0.8} className="py-24 md:py-32" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-32">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-white text-[28px] md:text-[48px] leading-tight font-serif mb-6" data-id="element-33">
          Your Free Device Is Waiting.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-brand-cream text-lg md:text-xl mb-10" data-id="element-34">
          Find out in 60 seconds if you qualify. No commitment, no credit check.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row justify-center gap-4 w-full sm:w-auto" data-id="element-35">
          <button className="w-full sm:w-auto bg-brand-gold text-brand-black px-8 py-4 rounded font-bold text-base hover:bg-yellow-500 transition-colors min-h-[52px]" data-id="element-36">
            Check Eligibility
          </button>
          <button className="w-full sm:w-auto bg-transparent border-2 border-brand-gold text-white px-8 py-4 rounded font-bold text-base hover:bg-brand-gold/10 transition-colors min-h-[52px]" data-id="element-37">
            Schedule Appointment
          </button>
        </motion.div>
      </div>
    </ParallaxSection>;
}